import { getLocale } from "../runtime";

const da_usp1 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Hurtig levering`
};

const en_usp1 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Fast home delivery`
};

const es_usp1 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Entrega rápida a domicilio`
};

const fi_usp1 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Nopea kotiinkuljetus`
};

const nb_usp1 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Rask hjemlevering`
};

const sv_usp1 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Snabb hemleverans`
};

const usp1 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_usp1(inputs)
	if (locale === "en") return en_usp1(inputs)
	if (locale === "es") return es_usp1(inputs)
	if (locale === "fi") return fi_usp1(inputs)
	if (locale === "nb") return nb_usp1(inputs)
	if (locale === "sv") return sv_usp1(inputs)
	return "usp1";
};

export { usp1 as "usp1" };